import {
  doFetchProductInvoice,
  doFetchOrderProduct,
  doFetchOrderProductForGuest,
  doFetchCustomerOrderProduct,
} from "@/services/product.service";
import { getField, updateField } from "vuex-map-fields";
import { snakeToCamel } from "@/services/util.service";

export const meProductOne = {
  namespaced: true,
  state: {
    fetchInProgress: true,
    productInvoice: {},
    orderProduct: {},
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,

    fetchInProgress(state, yesOrNo) {
      state.fetchInProgress = yesOrNo;
    },
    setProductInvoice(state, list) {
      state.productInvoice = list;
    },
    setOrderProduct(state, data) {
      state.orderProduct = data;
    },
  },
  actions: {
    fetchProductInvoice: async ({ commit }, itemId) => {
      let productInvoice = await doFetchProductInvoice(itemId);
      if (productInvoice) {
        commit("setProductInvoice", snakeToCamel(productInvoice));
      }
    },
    fetchOrderProduct: async ({ commit }, orderId) => {
      try {
        commit("fetchInProgress", true);
        // Use existing order product fetching
        let orderProduct = await doFetchOrderProduct(orderId);
        if (orderProduct) {
          commit("fetchInProgress", false);
          // No need for snakeToCamel as GraphQL data is already properly formatted
          commit("setOrderProduct", orderProduct);
          return orderProduct;
        }
      } catch (error) {
        commit("fetchInProgress", false);
        console.error("Error fetching order details:", error);
        throw error;
      }
    },
    fetchOrderProductForGuest: async (
      { commit },
      { orderId, email, lastName },
    ) => {
      try {
        commit("fetchInProgress", true);
        // Use existing order product fetching
        let orderProduct = await doFetchOrderProductForGuest({
          orderId,
          email,
          lastName,
        });
        if (orderProduct) {
          commit("fetchInProgress", false);
          // No need for snakeToCamel as GraphQL data is already properly formatted
          commit("setOrderProduct", orderProduct);
          return orderProduct;
        }
      } catch (error) {
        commit("fetchInProgress", false);
        console.error("Error fetching order details:", error);
        throw error;
      }
    },
    fetchCustomerOrderProduct: async ({ commit }, orderId) => {
      try {
        commit("fetchInProgress", true);
        // Use existing order product fetching
        let orderProduct = await doFetchCustomerOrderProduct(orderId);
        if (orderProduct) {
          commit("fetchInProgress", false);
          // No need for snakeToCamel as GraphQL data is already properly formatted
          commit("setOrderProduct", orderProduct);
          return orderProduct;
        }
      } catch (error) {
        commit("fetchInProgress", false);
        console.error("Error fetching order details:", error);
        throw error;
      }
    },
  },
};
